import * as React from 'react'
import { useSelector } from 'react-redux'
import { ModalComponentRow } from '@modals/modal-component-row'
import { selectAllModals } from '@store/slices/modal-slice'

export const ModalComponent: React.FC = () => {
  const modals = useSelector(selectAllModals)

  return (
    <>
      {modals.map(({ modal, params, config, isOpen }) => (
        <ModalComponentRow config={config} key={modal} isOpen={isOpen} modal={modal} params={params} />
      ))}
    </>
  )
}
